import { PropsWithChildren, useRef } from 'react'

import { useCreation } from 'ahooks'

import { PreviewFileRef } from '@eastcoal/common/components/PreviewFile/interface'

import { RichEditorStoreContext } from './contexts/StoreContext'
import { RichEditorStoreProviderProps } from './interface'
import { createRichEditorStore } from './store/createStore'

export const RichEditorStoreProvider = ({
  children,
  defaultFontFamily,
  defaultFontSize,
  defaultFontColor,
  defaultFontBackgroundColor,
  defaultLineHeight
}: PropsWithChildren<RichEditorStoreProviderProps>) => {
  const previewFileRef = useRef<PreviewFileRef>(null)
  const store = useCreation(
    () =>
      createRichEditorStore({
        previewFileRef,
        defaultFontFamily,
        defaultFontSize,
        defaultFontColor,
        defaultFontBackgroundColor,
        defaultLineHeight
      }),
    []
  )

  return (
    <RichEditorStoreContext value={store}>{children}</RichEditorStoreContext>
  )
}
